var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('div',[_c('span',{staticClass:"body-2 heavy",domProps:{"innerHTML":_vm._s(_vm.highlightedArticleId(_vm.articleNo))}}),_c('span',[_c('ArticleMessageIndicator',{attrs:{"article":_vm.article}})],1)]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.highlightedArticleName(_vm.article.name))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }